module.exports = __webpack_public_path__ + "static/media/S (62).b6571dba.jpg";